import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type CanvasStructure {\n    type: String\n    id: Int\n  }\n\n  type CanvasPageMeta {\n    title: String\n    keywords: String\n    description: String\n    robots: String\n  }\n\n  type CanvasStructureConnection {\n    data: [CanvasStructure]\n    meta: CanvasPageMeta\n    pageInfo: PageInfo\n  }\n\n  type Query {\n    canvas(idKey: String, offset: Int, limit: Int): CanvasStructureConnection\n  }\n"])));
export var resolvers = {
  Query: {
    canvas: function () {
      var _canvas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var idKey, offset, limit, dataSources, _res$values, res, structure, meta;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idKey = _ref.idKey, offset = _ref.offset, limit = _ref.limit;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.canvas.getCanvas(idKey);

              case 5:
                res = _context.sent;
                structure = res.structure;
                meta = _objectSpread({
                  title: res.name
                }, (_res$values = res.values) === null || _res$values === void 0 ? void 0 : _res$values.meta);
                return _context.abrupt("return", {
                  data: structure.slice(offset, offset + limit),
                  meta: meta,
                  pageInfo: createPageInfo({
                    limit: limit,
                    offset: offset,
                    count: structure.length
                  })
                });

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                console.log("canvas schema query error", _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      }));

      function canvas(_x, _x2, _x3) {
        return _canvas.apply(this, arguments);
      }

      return canvas;
    }()
  }
};